import React from 'react'

function AboutPage() {
  return (
    <div className='text-4xl text-white'>AboutPage</div>
  )
}

export default AboutPage